// wallet captcha v3 analytics actions
export const WALLET_CAPTCHA_ANALYTICS = 'WALLET_CAPTCHA_ANALYTICS';

export default WALLET_CAPTCHA_ANALYTICS;
